module.exports = __webpack_public_path__ + "static/media/inv-glider1.f8c79a87.svg";